import { Record } from 'immutable';

export default class DocumentTemplateRecord extends Record({
  id: undefined,
  title: undefined,
  description: undefined,
  category: undefined,
  content: undefined,
  isActive: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  createdBy: undefined,
  staffingCompanyGroup: undefined,
  availablePlaceholders: undefined,
  links: undefined,
  _type: undefined,
}) {
}
